import SearchIcon from "@material-ui/icons/Search";
import { BLUE_PRIMARY, ERROR_COLOR } from "../../utils/const";

const NotFound = (props) => {
  const text = props.text ? props.text : "هیچ موردی یافت نشد.";
  const showText = props.showText === undefined ? true : props.showText;
  const code = "404";
  const iconSize = props.iconSize === undefined ? 128 : props.iconSize;
  const textSize = props.textSize === undefined ? 16 : props.textSize;
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        <SearchIcon
          style={{ fontSize: iconSize + "px", color: BLUE_PRIMARY }}
        />

        <p
          style={{
            display: showText ? "" : "none",
            marginTop: "0",
            fontSize: textSize + "px",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
        <p
          style={{
            display: showText ? "" : "none",
            marginTop: "0",
            fontSize: "22px",
            fontWeight: "bold",
            color: ERROR_COLOR,
          }}
        >
          {code}
        </p>
      </div>
    </>
  );
};

export default NotFound;
